import React, { Component, ReactNode } from 'react';
import { handleRuntimeChunkError, isChunkLoadError } from '../utils/runtimeStability';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ChunkErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  async componentDidCatch(error: Error, errorInfo: any) {
    console.error('Chunk loading error:', error, errorInfo);

    const handled = await handleRuntimeChunkError(error, 'chunk-boundary');
    if (!handled && !isChunkLoadError(error)) {
      console.error('Non-chunk error:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div style={{
          padding: '40px',
          textAlign: 'center',
          background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
          borderRadius: '12px',
          margin: '20px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          border: '1px solid #dee2e6'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔄</div>
          <h3 style={{ color: '#dc2626', marginBottom: '16px', fontSize: '20px' }}>
            Sayfa Yüklenirken Sorun Oluştu
          </h3>
          <p style={{ color: '#6b7280', marginBottom: '20px', lineHeight: '1.5' }}>
            Sayfa bileşenleri yüklenirken geçici bir sorun yaşandı.<br/>
            Bu genellikle ağ bağlantısı veya önbellek sorunlarından kaynaklanır.
          </p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: 'linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%)',
                color: 'white',
                padding: '12px 24px',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                boxShadow: '0 2px 4px rgba(59, 130, 246, 0.3)'
              }}
            >
              🔄 Sayfayı Yenile
            </button>
            <button
              onClick={() => window.history.back()}
              style={{
                background: '#6b7280',
                color: 'white',
                padding: '12px 24px',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500'
              }}
            >
              ← Geri Dön
            </button>
          </div>
          <p style={{ color: '#9ca3af', fontSize: '12px', marginTop: '20px' }}>
            Sorun devam ederse lütfen sistem yöneticinizle iletişime geçin.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ChunkErrorBoundary;
